import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarm,
  CPSConfigAlarmElement,
  CPSConfigCard,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';
import { P00039DataRxTxIndex } from '../../P00039Sync';

export function P00043Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('paSAlarme') === 1) {
    if (
      getValue('paSArretCommandDebit') === 1 &&
      ((getValue('paCModeFonctionnement') === 1 &&
        getValue('paSCommandeHorloge') === 1) ||
        getValue('paCModeFonctionnement') === 3)
    ) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle:
          getValue('paPModeRegulation') === 0
            ? 'P00043.dashboard.card.title.warm'
            : 'P00043.dashboard.card.title.cold',
        title: 'P00043.status.arretDeLaCommande',
      });
    }

    if (masterClass.hasProduct(pool, productClass) === 2) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.PAC,
        functionalityTitle:
          getValue('paPModeRegulation') === 0
            ? 'P00043.dashboard.card.title.warm'
            : 'P00043.dashboard.card.title.cold',
        title: 'P00043.status.presenceDuProduit',
      });
    }
  }

  return res;
}
